import React, { useState, useContext, useEffect, useRef } from 'react'
import "./additems.css"
import CartContext from '../../context/cart_context';
import { db } from '../../config/firebase_config';
import { get, query, ref } from 'firebase/database';
import { WhiteSpinner } from '../mini-components/mini-components';
import FoodItem from '../food-item/FoodItem';
import RestaurentFoodModel from '../../models/Restaurent_food_model';
import { IoIosCloseCircle } from "react-icons/io";


const AddItems = ({ item }) => {

  const [count, setCount] = useState(0);
  const [isLoading, setisLoading] = useState(false);
  const dialogRef = useRef();
  const [addOns, setaddOns] = useState([]);
  const { cartItems, addCartItem } = useContext(CartContext);

  function toggleDialog() {
    if (dialogRef.current?.hasAttribute("open")) {
      dialogRef.current?.close();
      dialogRef.current.className = ""
      document.body.style.overflow = 'auto';
    } else {
      dialogRef.current?.showModal();
      // dialogRef.current.className = "show-dialog"  
      document.body.style.overflow = 'hidden';
    }
  }


  useEffect(() => {
    console.log("use Effect initated");
    if (cartItems[item.dbID]) {
      setCount(cartItems[item.dbID]);
    }
  }, [])


  const checkAddons = async () => {
    setisLoading(true)
    try {
      const addonRef = ref(db, `${item.dbID}_${item.name}`);
      const dataSnap = await get(query(addonRef));
      if (dataSnap.exists()) {
        const foodItems = [];
        const data = dataSnap.val();
        console.log(data, "<<<< addons >>");
        Object.entries(data).forEach(([key, value]) => {
          const restItem = RestaurentFoodModel.fromJson(key, value);
          // if (isRestCategoryAvailable(restItem) &&  restItem.visibility == "Yes" ) {
          foodItems.push(restItem);
          // }
        });
        setaddOns(foodItems);
        toggleDialog();

      } else {
        console.log("endi ra idii ...run avtaleud");
      }

    } catch (e) {
      console.log(e);
    }

    setisLoading(false);

  }

  return (
    <>
      <div className='add-items-container' >
        {cartItems[item.dbID] == null
          ? <p onClick={async () => {
            setCount(1);
            addCartItem(item, 1)
            await checkAddons();
          }
          } >ADD</p> :
          isLoading ? <WhiteSpinner /> :
            <>
              <button onClick={() => { setCount((prev) => prev - 1); addCartItem(item, count - 1) }}>-</button>
              <p>{cartItems[item.dbID]}</p>
              <button onClick={async () => {
                setCount((prev) => prev + 1);
                addCartItem(item, count + 1);
              }}>+</button>
            </>

        }
      </div>
      <dialog
        ref={dialogRef}
        onClick={(e) => {
          if (e.currentTarget == e.target) {
            toggleDialog()
          }
        }}
      >
        <div className='show-dialog'>
          <div className='addon-dialog'>
            <div className='title'>
              <p className='addon-text'>Add-ons</p>
              <IoIosCloseCircle onClick={toggleDialog} />
            </div>
            <ul className='items'>
              {
                addOns.map((val, index) => <FoodItem key={index} item={val} isLast={index == addOns.length - 1} />)
              }
            </ul>
          </div>

        </div>
      </dialog>
    </>
  )
}

export default AddItems